module.exports = __webpack_public_path__ + "img/9_99.5d1a2c1a.png";